
(() => {
  const swipers = new Map();

  function initSliders(root = document) {
    if (typeof Swiper === "undefined") return;

    const slideshows = root.querySelectorAll(
      ".slideshow__swiper"
    );

    slideshows.forEach((slideshow) => {
      if (swipers.has(slideshow)) return;

      const slides = slideshow.querySelectorAll(
        ".swiper-slide"
      );

      if (!slides.length) return;

      const multipleSlides = slides.length > 1;
      const autoplayEnabled =
        slideshow.dataset.autoplay === "true" &&
        multipleSlides;

      const duration = Number(
        slides[0].dataset.swiperAutoplay
      ) || 5000;

      const nextButton = slideshow.querySelector(
        ".swiper-button-next"
      );

      const prevButton = slideshow.querySelector(
        ".swiper-button-prev"
      );

      const swiper = new Swiper(slideshow, {
        slidesPerView: 1,
        spaceBetween: 0,

        loop: multipleSlides,

        // Aktif slayta göre yüksekliği güncelle
        autoHeight: true,
        speed: 500,

        simulateTouch: true,
        allowTouchMove: multipleSlides,
        watchSlidesProgress: true,
        preventInteractionOnTransition: true,

        observer: true,
        observeParents: true,
        resizeObserver: true,

        navigation: {
          nextEl: nextButton,
          prevEl: prevButton,
        },

        autoplay: autoplayEnabled
          ? {
              delay: duration,
              disableOnInteraction: false,
              pauseOnMouseEnter: true,
            }
          : false,

        mousewheel: {
          forceToAxis: true,
        },

        on: {
          init(swiper) {
            swiper.updateAutoHeight(0);
          },

          slideChangeTransitionEnd(swiper) {
            swiper.updateAutoHeight(300);
          },

          resize(swiper) {
            swiper.update();
            swiper.updateAutoHeight(0);
          },
        },
      });

      swipers.set(slideshow, swiper);

      if (multipleSlides) {
        slideshow.classList.add(
          "slideshow__swiper--multiple-slides"
        );
      }

      // Görseller yüklendiğinde yüksekliği yeniden hesapla
      const images = slideshow.querySelectorAll("img");

      images.forEach((img) => {
        if (!img.complete) {
          img.addEventListener(
            "load",
            () => {
              swiper.update();
              swiper.updateAutoHeight(0);
            },
            { once: true }
          );
        }
      });

      swiper.update();
      swiper.updateAutoHeight(0);
    });
  }

  function destroySliders(root) {
    const slideshows = root.querySelectorAll(
      ".slideshow__swiper"
    );

    slideshows.forEach((element) => {
      const swiper = swipers.get(element);

      if (swiper) {
        swiper.destroy(true, true);
        swipers.delete(element);
      }
    });
  }

  initSliders();

  document.addEventListener(
    "shopify:section:load",
    (event) => {
      initSliders(event.target);
    }
  );

  document.addEventListener(
    "shopify:section:unload",
    (event) => {
      destroySliders(event.target);
    }
  );
})();
